import { render } from "./a_bis.vue?vue&type=template&id=33067378"
import script from "./a_bis.vue?vue&type=script&lang=js"
export * from "./a_bis.vue?vue&type=script&lang=js"

import "./a_bis.vue?vue&type=style&index=0&id=33067378&lang=less"
script.render = render

export default script